<template>
  <div>
    <contentwrapper>
      <div class="vrAntwOuter">
        <div class="vrAntwInner">
          <div class="row">
            <div class="col-md-11 col-sm-10 col-xs-9">
              <font-awesome-icon icon="question-square" />&nbsp;
              <span>{{ lblVerzender }}</span>
            </div>
            <div class="col-md-1 col-sm-2 col-xs-3">
              <div class="pull-right">
                <span id="vaImportant">
                  <font-awesome-icon icon="exclamation-triangle" v-show="showPrioriteit" />
                </span>
                <span v-on:click="toggleVraag()">
                  <font-awesome-icon
                    icon="chevron-down"
                    class="initial"
                    v-bind:class="{ hideIcon: chevronFlip }"
                  />
                  <font-awesome-icon
                    icon="chevron-up"
                    class="initial"
                    v-bind:class="{ hideIcon: !chevronFlip }"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="row" v-show="showDetails">
            <div class="col-md-12">
              <span id="spanOntvangers">{{ lblOntvanger }} {{ lblOntvangers }}</span>
            </div>
          </div>
          <div class="row margin10">
            <div class="col-md-12">
              <span v-on:click="toggleVraag()">{{ lblOnderwerp }}</span>
            </div>
          </div>
          <div class="row margin10" v-show="showDetails">
            <div class="col-md-11">
              <span v-on:click="toggleVraag()">{{ lblVraag }}</span>
            </div>
          </div>
          <div class="row margin10">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <span
                id="spanReacties"
                v-on:click="toggleAntwoorden()"
              >{{ lblAantalReacties }} {{ lblReacties }}</span>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6">
              <span id="spanDate" class="pull-right">{{ lblDatumTijd }}</span>
            </div>
          </div>
        </div>
        <div class="row rowreply" v-show="showDetails">
          <div class="col-md-12 colreply" v-show="showDetails">
            <button class="butReply">
              <font-awesome-icon icon="reply" />
              &nbsp;{{ lblButReply }}
            </button>
          </div>
        </div>
        <div class="vrAntwReply" v-show="showAntwoorden">
          <div
            class="vrAntwInnerReply"
            v-for="(item) in items"
            v-bind:key="item.id"
            v-show="showAntwoorden"
          >
            <antwoord :id="item.id"></antwoord>
          </div>
        </div>
      </div>
    </contentwrapper>
  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
import antwoord from './vraagAntwoord_antw.vue'
// naar pagina gaan via http://pe/peapp/vraagAntwoord/

export default {
  name: 'vraagAntwoord',
  mixins: [FAMixin],
  data() {
    return {
      titel: 'hoi',
      lblVerzender: 'GAIA-Test',
      lblOntvanger: 'Ontvangers: ',
      lblOntvangers: 'Aanbieder Academisch Medisch Centrum',
      lblOnderwerp: 'Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero',
      lblVraag:
        'Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus.',
      lblAantalReacties: 0,
      lblReacties: 'Reacties',
      lblDatumTijd: '12-03-2018, 09:34',
      lblButReply: 'Beantwoord',
      showDetails: false,
      showAntwoorden: false,
      chevronFlip: false,
      showPrioriteit: true,
      items: [
        { id: 345, naam: 'Foo', antwoord: 'dit is een antwoord' },
        { id: 234, naam: 'Bar', antwoord: 'dit is ook een antwoord' }
      ]
    }
  },
  components: {
    antwoord: antwoord
  },
  methods: {
    toggleVraag() {
      this.chevronFlip = !this.chevronFlip
      this.showDetails = !this.showDetails
      if (this.showAntwoorden === true) {
        this.showAntwoorden = false
      }
    },
    toggleAntwoorden() {
      if (this.showDetails === false) {
        this.showDetails = true
        this.chevronFlip = true
      }
      this.showAntwoorden = !this.showAntwoorden
    }
  }
}
</script>
<style>
.hideIcon {
  display: none;
}
.vrAntwOuter {
  position: absolute;
  background-color: #ffffff;
  width: 100%;
  box-shadow: 0px 4px 9px 2px rgba(119, 119, 119, 0.7);
  -moz-box-shadow: 0px 4px 9px 2px rgba(119, 119, 119, 0.7);
  -webkit-box-shadow: 0px 4px 9px 2px rgba(119, 119, 119, 0.7);
}
.vrAntwInner {
  padding: 20px 20px 10px 20px;
}
.vrAntwInnerReply {
  padding-left: 20px;
  padding-bottom: 5px;
}
.vrAntwReply {
  margin: 0;
}
@media (max-width: 751px) {
  .vrAntwReply {
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
#vaImportant {
  margin-right: 15px;
  color: red;
}
.rowreply {
  border-top: 1px solid lightgray;
  margin-top: 10px;
  margin-left: 0px;
  margin-right: 0px;
}
@media (max-width: 751px) {
  .rowreply {
    border: 0;
    margin: 0;
  }
}
.colreply {
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}
@media (max-width: 751px) {
  .colreply {
    margin-bottom: 0;
    margin-left: -15px;
    margin-right: -15px;
  }
}
.butReply {
  /* dit worden kleuren van de knoppen van de klant: bijv niv #006633*/
  color: black;
  border: 1px solid lightgray;
  background-color: lightgray;
}
@media (max-width: 751px) {
  .butReply {
    width: 100%;
    height: 35px;
    font-size: 12px;
  }
}
#spanOntvangers,
#spanReacties,
#spanDate,
#spanBijlage {
  color: lightslategray;
}
@media (max-width: 751px) {
  #spanOntvangers,
  #spanReacties,
  #spanDate,
  #spanBijlage {
    font-size: 12px;
  }
}
</style>
